/* eslint-disable */
import _ from 'underscore';
import BaseModel from '@bingads-webui-campaign-legacy/bulk-operation/util/bulk-edit-job';
var model = BaseModel.extend({
  defaults: _.extend({}, BaseModel.prototype.defaults, {
    Entity: '',
    BatchAction: {
      Actions: [{
        '@odata.type': '#Model.CopyAction',
        DestinationParentEntityIds: []
      }],
      EditCopy: false
    },
    Description: 'Copy Paste'
  })
});
export default model;

